import { useEffect, useState } from "react";
import { Badge, Button, Col, Form, Label, Modal, ModalBody, ModalHeader, Row } from "reactstrap";
import Head from "../../../layout/head/Head";
import Content from "../../../layout/content/Content";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Icon,
  PreviewAltCard,
} from "../../../components/Component";
import MySelect from "../../../MyComp/UI/form/MySelect";

import DeleteModal from "../../../MyComp/UI/modals/DeleteModal";
import ConfirmModal from "../../../MyComp/UI/modals/ConfirmModal";
import MyButton from "../../../MyComp/UI/form/MyButton";
import useLogout from "../../../hooks/useLogout";
import ViewImgAndPdf from "../../ImageFolder/ViewImageAndPdf";
import MyDataTable from "../../../MyComp/UI/DataTable/MyDataTable";
import Status from "../../../MyComp/UI/form/Status";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { categoryPackageDDAPI, categoryTestDDAPI, subCategoryDDAPI, testDDAPI } from "../../../api/dropdown";
import { UserAvatarCell } from "../../../MyComp/ImageView/UserAvatarCell";
import { BASE_EXCEL_URL, BASE_URL_IMG } from "../../../assets/constants";
import {
  createSubGroupAPI,
  createSubGroupLabAPI,
  deleteTestLabSubCategory,
  deleteTestSubCategory,
  listLabSubGroupAPI,
  listSubGroupAPI,
  updateGroupAPI,
  updateSubGroupAPI,
  updateSubLabGroupAPI,
  uploadLabTestCatalog,
  uploadTestCatalog,
} from "../../../api/master/indes";
import MyInput from "../../../MyComp/UI/form/MyInput";
import ImageUpload from "../../../MyComp/UI/form/ImageUpload";
import MyTextArea from "../../../MyComp/UI/form/MyTextArea";

const LabSubGroup = () => {
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    trigger,
    clearErrors,
    getValues,
    setError,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      isLoading: true,
      addSub: false,
      data: [],
    },
  });
  const logout = useLogout();
  const [isOpen, setIsOpen] = useState(false);
  const [mode, setMode] = useState("Add");
  const isLoading = watch("isLoading");
  const data = watch("data");
  const [imageOpen, setImageOpen] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  // Table Columns
  const [column, setColumn] = useState([
    {
      name: "Image",
      selector: (row) => (
        <div>
          {/* <img
            style={{ width: "50px", height: "50px", borderRadius: "6px" }}
            src={row?.image ? `${BASE_URL_IMG}${row.image}` : "/default-avatar.png"}
          /> */}
          <UserAvatarCell
            row={row}
            name={row?.subgroup}
            handleImageOpenPreview={handleImageOpenPreview}
            image={`${BASE_URL_IMG}${row.image}`}
          />
        </div>
      ),
      sortable: false,
      wrap: true,
    },
    {
      name: "Group Name",
      selector: (row) => row?.group,
      sortable: true,
    },
    {
      name: "Sub Group ",
      selector: (row) => row?.subgroup || "-",
      sortable: true,
      wrap: true,
    },
    {
      name: "Status",
      selector: (row) => row?.status,
      cell: (row) => (
        <div style={{ cursor: "pointer" }} onClick={() => handleToggleStatus(row)}>
          <Badge color={row.status ? "success" : "danger"}>{row.status ? "Active" : "Inactive"}</Badge>
        </div>
      ),
      sortable: true,
      wrap: true,
      // width: "90px",
    },
    {
      name: "Action",
      wrap: true,
      width: "120px",
      cell: (row) => (
        <div>
          <Button outline color="warning" size="xs" className="me-1" onClick={() => handleEdit(row)}>
            <Icon name="edit" />
          </Button>{" "}
          <Button outline color="danger" size="xs" onClick={() => handleDeleteClick(row)}>
            <Icon name="trash" onClick={() => handleDeleteClick(row)} />
          </Button>
        </div>
      ),
    },
  ]);
  const discountType = [
    { value: "percentage", label: "percentage" },
    {
      value: "fixed",
      label: "fixed",
    },
  ];
  const handleDeleteClick = (row) => {
    // setSelectedRow(row);
    setValue("selectedRow", row);
    setShowDeleteModal(true);
  };

  const confirmDelete = () => {
    if (!watch("selectedRow")) return;

    // setLoading(true);
    setValue("isLoading", true);

    deleteTestLabSubCategory({ id: watch("selectedRow").id })
      .then((res) => {
        setValue("isLoading", false);
        setShowDeleteModal(false);
        if (res.data.status === true) {
          toast.success(res.data.message);
          //   setTableData((prev) => prev.filter((item) => item.id !== watch("selectedRow").id));
          setValue(
            "data",
            watch("data").filter((item) => item.id !== watch("selectedRow")?.id),
          );
        } else if (res.data.status === "expired") {
          toast.error(res.data.message);
          logout();
        } else {
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        // setLoading(false);
        setValue("isLoading", false);
        toast.error(err?.response?.data?.message);
      });
  };
  // Fetch group list
  useEffect(() => {
    getGroupList();
  }, []);

  const getGroupList = async () => {
  const body = { labId: localStorage.getItem("userId") };

  try {
    const res = await listLabSubGroupAPI(body);

   
    if (res?.data?.status === "expired") {
      toast.error(res.data.message);
      toast.clearWaitingQueue();
    } 
    else if (res?.data?.status === true) {
      setValue("data", res.data.data);
    } 
    else {
      setValue("data", []);
      toast.error(res.data.message);
    }

  } catch (err) {

    toast.error(err?.response?.data?.message || "Something went wrong");
  } finally {
    setValue("isLoading", false);
  }
};


  const onFormSubmit = async (data) => {
    try {
      setValue("isLoading", true);

      const formData = new FormData();

      // formData.append("package_name", data?.package_name);
      formData.append("Category", data?.category.label);
      // formData.append("discount", data?.discount);
      formData.append("labId", localStorage.getItem("userId"));
      // formData.append("Type",data?.discountType?.value);
      formData.append("Type", data?.category_type);

      // formData.append("discountType", data?.discountType?.value);
      // formData.append("package_price", data?.mrp);
      // Description
      const desc = watch("description");
      if (Array.isArray(desc)) {
        formData.append("package_description", JSON.stringify(desc.map((d) => d.label)));
      }
      formData.append("status", data?.status?.value);

      // formData.append("categoryId", data?.category?.value);

      if (data?.group_img instanceof File) {
        formData.append("image", data.group_img);
      }

      if (mode === "Edit") {
        formData.append("id", watch("selectedRow")?.id);
      }

      const res = mode === "Add" ? await createSubGroupLabAPI(formData) : await updateSubLabGroupAPI(formData);

      if (res?.data?.status === true) {
        toast.success(res.data.message);
         getGroupList();
        resetF();
        setIsOpen(false);
           setMode("Add");
      } else if (res?.data?.status === "expired") {
        toast.error(res.data.message);
        logout();
      } else {
        toast.error(res?.data?.message || "Operation failed");
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || "Something went wrong");
    } finally {
      setValue("isLoading", false);
    }
  };

  const handleEdit = (row) => {
    window.scrollTo(0, 0);

    setMode("Edit");
    setIsOpen(true);

    // Group (Category)
    setValue("category", {
      label: row.group,
      value: row.group,
    });

    // Sub Group Name
    setValue("name", row.subgroup || "");

    // Status
    setValue("status", {
      label: row.status ? "Active" : "Inactive",
      value: row.status,
    });

    // Image preview URL
    setValue("group_image", `${BASE_URL_IMG}${row.image}`);
    setValue("category_type", row.subgroup || "");
    // Actual file input should be null on edit
    setValue("group_img", null);

    // Optional fields
    setValue("description", row.subgroup || "");

    // Store selected row (for update API)
    setValue("selectedRow", row);
  };

  useEffect(() => {
    getCategory();
  }, [mode]);
  const getCategory = () => {
    categoryTestDDAPI()
      .then((res) => {
        //const status = decrypt(res.data.status);
        if (res.data.status === true) {
          // toast.success(res.data.message);
          toast.clearWaitingQueue();
          setValue("categoryDD", res.data.data);
          setValue("isLoading", false);
        } else if (res.data.status === false) {
          setValue("isLoading", false);
          setValue("categoryDD", []);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
        } else if (res.data.status === "expired") {
          console.log("token expired", res.data);
          setValue("isLoading", false);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        }
      })
      .catch((err) => {
        setValue("isLoading", false);
        toast.error(err?.response?.data?.message);
      });
  };

  const handleToggleStatus = (row) => {
    setValue("selectedRow", row);
    setShowModal(true);
  };

  const confirmStatusChange = async () => {
    const updatedStatus = !watch("selectedRow").status;
    setValue("isLoading", true);
    const formObject = {
      // id: watch("selectedRow").id,
      status: updatedStatus,
    };

    try {
      const res = await updateGroupAPI(formObject);
      if (res.data.status === true) {
        // toast.success(res.data.message);
        // await getGroupList();
      } else if (res.data.status === "expired") {
        // toast.error(res.data.message);
        logout();
      } else {
        // toast.error(res.data.message);
      }
    } catch (err) {
      // toast.error(err?.response?.data?.message);
    } finally {
      setValue("isLoading", false);
      setShowModal(false);
    }
  };

  const handleImageOpenPreview = (row) => {
    // const imageUrl = `${BASE_URL_IMG}${row?.image}`;
    setValue("image_preview", row);
    setImageOpen(true);
  };

  const resetF = () => {
    setValue("group_image", null);
    setValue("group", "");
    setValue("category_type", "");
    setValue("category", "");
    setValue("status", null);
    setValue("addSub", false);
    setValue("group_img", null);
        clearErrors()
  };

  const handleImageClose = () => {
    setImageOpen(false);
  };
  const {
    clearErrors: clearErrorsTest,
    register: registerTest,
    handleSubmit: handleSubmitTest,
    control: controlTest,
    setValue: setValueTest,
    watch: watchTest,
    trigger: triggerTest,
    formState: { errors: errorsTest },
    reset: resetTest,
    setError: setErrorTest,
  } = useForm({
    defaultValues: {
      isLoading: false,
      addSub: false,
      data: [],
    },
    mode: "onChange",
  });
  const handleUploadClick = () => {
    setDownloadModalOpen(true);
  };
  const labId = localStorage.getItem("userId");
  const [downloadModalOpen, setDownloadModalOpen] = useState(false);
  // New: Handle Upload click to show download modal
  const uploadTestCatalogAPI = async () => {
    try {
      setUploading(true);
      const file = watchTest("file");
      if (!file) {
        toast.errorsTest("Please select an Excel file");
        return;
      }
      const formData = new FormData();
      formData.append("file", file);
      formData.append("labId", labId);

      const res = await uploadLabTestCatalog(formData);

      if (res?.data?.status === "expired") {
        toast.error(res.data.message);
        toast.clearWaitingQueue();
        getGroupList();
        logout();
      } else if (res?.data?.status === true) {
        toast.success(res.data.message || "Excel uploaded successfully");
        handleCancel();
        getGroupList();
        setDownloadModalOpen(false);
        setValueTest("data", res.data.data || []);
      } else {
        toast.error(res?.data?.message || "Upload failed");
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || "Upload failed");
    } finally {
      setUploading(false);
    }
  };

  const handleChange = (e) => {
    const selectedFile = e.target.files[0];

    if (!selectedFile) {
      setValueTest("file", null);
      setErrorTest("file", { type: "manual", message: "File is required" });
      return;
    }

    validateExcel(selectedFile, (isValid) => {
      if (isValid) {
        clearErrorsTest("file");
        setValueTest("file", selectedFile);
      } else {
        setValueTest("file", null);
        setErrorTest("file", { type: "manual", message: "Invalid file type. Please upload a valid Excel file." });
        toast.error("Invalid file type. Please upload a valid Excel file.");
        e.target.value = null;
      }
    });
  };
  useEffect(() => {
    if (!downloadModalOpen) {
      setValueTest("file", null);
      clearErrorsTest("file");

      // reset actual file input DOM value
      const input = document.getElementById("fileInput");
      if (input) {
        input.value = "";
      }
    }
  }, [downloadModalOpen]);
  const handleCancel = () => {
    setValueTest("file", null);
    clearErrorsTest("file");

    const input = document.getElementById("fileInput");
    if (input) {
      input.value = "";
    }
  };

  // const handleCancel = () => {
  //   setValue("file", null);
  //   clearErrors("file");
  // };
  const validateExcel = (file, callback) => {
    const reader = new FileReader();

    const fileName = file.name.toLowerCase();
    const isXlsExtension = fileName.endsWith(".xls");
    const isXlsxExtension = fileName.endsWith(".xlsx");

    if (!isXlsExtension && !isXlsxExtension) {
      callback(false);
      return;
    }

    reader.onloadend = function (event) {
      const arr = new Uint8Array(event.target.result).subarray(0, 4);
      let header = "";
      for (let i = 0; i < arr.length; i++) {
        header += arr[i].toString(16).padStart(2, "0");
      }
      header = header.toUpperCase();

      const isXls = header === "D0CF11E0"; // XLS
      const isXlsx = header === "504B0304"; // XLSX
      const isExcel = (isXls && isXlsExtension) || (isXlsx && isXlsxExtension);

      callback(isExcel);
    };

    reader.onerror = function () {
      callback(false);
    };

    reader.readAsArrayBuffer(file.slice(0, 4));
  };
  const [uploading, setUploading] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);

  const handleSampleFileOpen = () => {
    const upload = "upload-test-catalog";
    const fileName = `${BASE_URL_IMG}${upload}`;
    // Replace 'sample_file.txt' with the name of your sample file
    // const fileName = watch("file_name");
    var filePath;
    // Path to your sample file
    // if (selectedType?.value == "facility") {
    filePath = ` ${watch("file_name")}`; // Update the path
    // } else {
    //   filePath = `${base}${sampelFileV2}`; // Update the path
    // }
    const link = document.createElement("a");
    link.href = filePath;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <>
      <Head title=" Sub Group | Master" />
      <Content>
        <BlockHead size="sm" className="mb-0 pb-0">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page tag="h3">
                Manage Sub Group
              </BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <>
                {/* <Button color="primary" outline style={{ marginRight: "15px" }} onClick={handleUploadClick}>
                  <Icon name="upload" />
                </Button> */}
                   {mode === "Edit" && ( <Button
                  color="primary"
                  outline
                  className="me-n1"
                  onClick={() => {
                    setIsOpen((pre) => !pre);
                    setMode("Add");
                    resetF();
                  }}
                >
                  <Icon name={isOpen ? "minus" : "plus"} />
                </Button>)}
              </>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        <Block className="pt-0">
          {isOpen && (
            <PreviewAltCard>
              <Form onSubmit={handleSubmit(onFormSubmit)}>
                <Row>
                  {/* <Col md="3">
                    <MyInput
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title="Package Name"
                      name="package_name"
                      placeholder="Enter package name"
                      required
                      min={2}
                      max={50}
                      disabled={mode == "Approval"}
                    />
                  </Col> */}
                  {/* <Col md="3">
                    <MyInput
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title="Category Name"
                      name="category"
                      placeholder="Enter category name"
                      required
                      min={2}
                      max={50}
                      disabled={mode == "Approval"}
                    />
                  </Col> */}

                  <Col md="3" className={``}>
                    <MySelect
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title={"Group"}
                      name={"category"}
                      placeholder={"Select Category"}
                      required
                      options={watch("categoryDD")}
                      // multi
                    />
                  </Col>
                  <Col md="3">
                    <MyInput
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title="Sub Group"
                      name="category_type"
                      placeholder="Enter category type"
                      required
                      // min={2}
                      // max={50}
                      disabled={watch("addSub")}
                      readonly
                    />
                  </Col>
                  <Col md="3">
                    <ImageUpload
                      name="group_image"
                      id="group_image"
                      watch={watch}
                      label="Upload Sub Group Image"
                      errors={errors}
                      register={register}
                      trigger={trigger}
                      clearErrors={clearErrors}
                      image="group_img"
                      image_url="group_image"
                      setValue={setValue}
                      handleImageOpenPreview={handleImageOpenPreview}
                      required
                      setError={setError}
                      getValues={getValues}
                    />
                  </Col>
                  {/* <Col md="3">
                    <MySelect
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title="Discount Type"
                      name="discountType"
                      placeholder="Select discount type"
                      required
                      options={discountType}
                      disabled={mode === "Approval"}
                    />
                  </Col> */}
                  {/* <Col md="3">
                    <MyInput
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title="MRP"
                      name="mrp"
                      placeholder="Enter MRP "
                      required
                      // min={2}
                      // max={50}
                      disabled={watch("addSub")}
                    />
                  </Col> */}

                  <Col md="3">
                    <Status
                      title={"Status"}
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                    />
                  </Col>
                  {/* <Col md="12" className={``}>
                    <MyTextArea
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title={"Description"}
                      name={"description"}
                      placeholder={"Tell us something about you"}
                      // required
                      // min={25}
                      // max={500}
                      cols={2}
                      row={2}
                      disabled={mode == "Approval"}
                    />
                  </Col> */}
                </Row>{" "}
                <Col md="2">
                  <MyButton isLoading={isLoading} mode={mode} />
                </Col>
              </Form>
            </PreviewAltCard>
          )}

          <MyDataTable data={data || []} columns={column} title="Sub Group List" isLoading={isLoading} />
        </Block>
      </Content>

      <ConfirmModal
        isOpen={showModal}
        toggle={() => setShowModal(!showModal)}
        onConfirm={confirmStatusChange}
        status={watch("selectedRow")?.status}
      />
      <DeleteModal
        showDeleteModal={showDeleteModal}
        setShowDeleteModal={setShowDeleteModal}
        confirmDelete={confirmDelete}
        selectedRow={watch("selectedRow")}
        loading={watch("isLoading")}
      />
      <ViewImgAndPdf url={watch("image_preview")} imageOpen={imageOpen} handleImageClose={handleImageClose} />
      <Modal isOpen={downloadModalOpen} toggle={() => setDownloadModalOpen(false)} centered>
        <ModalHeader toggle={() => setDownloadModalOpen(false)}>Upload Test Catalog (Excel)</ModalHeader>

        <ModalBody>
          <div className="d-block justify-content-between">
            <div
              style={{
                // maxWidth:'250px',
                border: "2px dashed #cfd4da",
                borderRadius: "10px",
                padding: "5px",
                textAlign: "center",
                background: "#f8f9fa",
              }}
            >
              {watchTest("file") ? (
                <div
                  style={{
                    border: "1px solid #dee2e6",
                    borderRadius: "10px",
                    padding: "20px",
                    background: "#ffffff",
                  }}
                >
                  <Icon name="file-excel" style={{ fontSize: "28px", color: "green" }} />
                  <p
                    style={{
                      marginTop: "10px",
                      wordBreak: "break-word",
                      fontWeight: "600",
                    }}
                  >
                    {watchTest("file")?.name}
                  </p>

                  <div className="d-flex justify-content-center gap-2 mt-3">
                    <Button color="danger" size="sm" className="p-2" outline onClick={handleCancel}>
                      Remove
                    </Button>
                    <Button
                      className="p-2"
                      color="primary"
                      size="sm"
                      disabled={uploading}
                      onClick={uploadTestCatalogAPI}
                    >
                      {/* {uploading ? "Uploading..." : "Upload"} */}
                      {"Upload"}
                    </Button>
                  </div>
                </div>
              ) : (
                /* FILE INPUT */
                <>
                  <label
                    htmlFor="fileInput"
                    style={{
                      cursor: "pointer",
                      display: "block",
                    }}
                  >
                    <Icon name="upload" style={{ fontSize: "30px", color: "#0d6efd" }} />
                    <p style={{ marginTop: "5px", fontWeight: "500" }}>Click to upload test catalog</p>
                    {/* <small style={{ color: "#6c757d" }}>
              Supported formats: .xls, .xlsx
            </small> */}
                  </label>

                  <input
                    type="file"
                    id="fileInput"
                    accept=".xls,.xlsx"
                    style={{ display: "none" }}
                    {...registerTest("file", { requiredTest: "File is required" })}
                    onChange={handleChange}
                  />

                  {errorsTest.file && (
                    <div style={{ color: "red", fontSize: "11px", marginTop: "5px" }}>{errorsTest.file.message}</div>
                  )}
                </>
              )}
            </div>

            {/* SAMPLE DOWNLOAD */}
            <div
              style={{
                border: "2px,solid,lightgray",
                borderRadius: "10px",
                paddingLeft: "50px",
                marginBottom: "10px",
                paddingTop: "15px",
                paddingRight: "25px",
                paddingBottom: "15px",
                marginTop: "10px",
                textAlign: "center",
                display: "flex",
                flexDirection: "column",
                gap: "6px",
                alignItems: "center",
              }}
            >
              <small style={{ color: "crimson" }}>Download sample Excel</small>
                     <a href={`${BASE_EXCEL_URL}/upload-lab-subgroup`} download>
                              <button className="btn btn-outline-primary btn-sm">
                                <Icon name="download" className="me-1" />
                                Sample
                              </button>
                            </a>
             
            </div>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

export default LabSubGroup;
